// extracted by mini-css-extract-plugin
module.exports = {"textInput":"NewSubsidiary_textInput__1A6Uk","logo":"NewSubsidiary_logo__3iJid","activeCheckbox":"NewSubsidiary_activeCheckbox__3gzDw"};